import React, { memo } from "react";
import styles from "./styles.module.scss";
import moment from "moment";
import Noimage from "../Noimage";
import { mediaLogo } from "helpers/constant";

const ListGroup = (props) => {
  const {
    title = "",
    badgeText = "",
    data = [],
    customClass = "",
    customOverflowclass = "",
    wrapclass = "",
    from = "",
  } = props;

  return (
    <div className={`${styles.listGroup} ${wrapclass}`}>
      <div className="d-flex flex-row">
        <h3 className={styles.title}>{title}</h3>
        {badgeText && <span className={styles.badgeColor}>{badgeText}</span>}
      </div>
      <div className={`${styles.overflowList} ${customOverflowclass}`}>
        {data.map((item, i) => {
          const key = `${title}${item.posted_at}${i}`;
          return (
            <a
              key={key}
              className={`${from === "notification" ? styles.notificationwrap : styles.listGroupItem} ${customClass}`}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="d-flex flex-row align-items-center w-100">
                <div className=" me-3 ">
                  {item.media ? (
                    <img
                      src={mediaLogo(item.media || "") || item.media}
                      width="36px"
                      height="36px"
                      alt="img"
                    />
                  ) : item.thumbnail_url ? (
                    <img
                      src={
                        mediaLogo(item.thumbnail_url || "") ||
                        item.thumbnail_url
                      }
                      width="24px"
                      height="24px"
                      alt="img"
                    />
                  ) : (
                    <Noimage
                      height="40px"
                      width="40px"
                      className={styles.noimage}
                    />
                  )}
                </div>
                <div className={styles.content}>
                  <div className="row">
                    <div className={!from ? "col-10" : "col-8"}>
                      <h5 className={styles.listTitle}>{item.title}</h5>
                      <div className={styles.listSubTitle}>
                        {item.description}
                      </div>
                    </div>
                    {(item.posted_at || item.created_at) && (
                      <div
                        className={`${!from ? "col-2 justify-content-end" : "col-4"} ps-0 ${styles.textMuted}`}
                      >
                        {item.posted_at
                          ? moment(item.posted_at).fromNow()
                          : moment(item.created_at).fromNow()}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </a>
          );
        })}
        {data.length === 0 && (
          <div className={styles.nodata}>No Data Available</div>
        )}
      </div>
    </div>
  );
};

export default memo(ListGroup);
